export default {
  // 用户流失列表
  'memberChurn.title': '用户流失列表',
  'memberChurn.vipLevels': 'VIP等级',
  'memberChurn.caliberDescription': '口径说明',
  'memberChurn.search': '查询',
  'memberChurn.reset': '重置',
  'memberChurn.export': '导出',
  'memberChurn.memberAccount': '会员账号',
  'memberChurn.realName': '会员真实姓名',
  'memberChurn.memberName': '会员昵称',
  'memberChurn.agentAccount': '上级代理账号',
  'memberChurn.registerInfo': '注册信息',
  'memberChurn.registerTime': '注册时间',
  'memberChurn.registerIp': '注册IP',
  'memberChurn.rechargeCount': '充值次数',
  'memberChurn.withdrawCount': '提现次数',
  'memberChurn.totalRecharge': '总充值（多币种）',
  'memberChurn.totalWithdraw': '总提现',
  'memberChurn.firstRechargeTime': '首充时间',
  'memberChurn.lastRechargeTime': '最近充值时间',
  'memberChurn.lastRechargeStartTime': '最近充值时间开始',
  'memberChurn.lastRechargeEndTime': '最近充值时间结束',
  'memberChurn.lastLoginTime': '最近登录时间',
  'memberChurn.lastBettingTime': '最后投注时间',
  'memberChurn.action': '操作',
  'memberChurn.view': '查看',
  'memberChurn.noData': '暂无数据',
  'memberChurn.defaultEmpty': '请选择查询条件',
  'memberChurn.requestFailed': '请求失败',
  'memberChurn.export.loading': '正在导出数据...',
  'memberChurn.export.success': '导出成功',
  'memberChurn.export.failed': '导出失败',
  'memberChurn.timeRangeWarning': '请选择时间范围',
  'memberChurn.export.noDataWarning': '请先搜索数据再进行导出',
  'memberChurn.export.needDataFirst': '请先搜索数据',
  'memberChurn.startTime': '最近充值时间（开始）',
  'memberChurn.endTime': '最近充值时间（结束）',
  'memberChurn.timeRangeError': '开始时间不能晚于结束时间',
  'memberChurn.depositTimeQueryTip': '【建议先选择最近充值时间进行查询】',
  'memberChurn.caliberTooltip': '流失口径：仅按充值判断。筛选「最近一次成功充值落在所选时间段内，且之后没有新的充值」的用户；默认展示：三天未充值用户（结束时间 = 今天 - 3 天，开始时间留空）；常见用法：只填写「结束时间」 → 查找「最近充值 ≤ 该日期，且至今无新充值」的用户；同时填写「开始 + 结束」 → 查找「最近充值在区间内，且至今无新充值」的用户；只填写「开始时间」 → 查找「最近充值 ≥ 该日期，且至今无新充值」的用户；举例：今天 8/27，结束时间选 8/24 → 筛选最近充值在 8/24 及之前，且 8/25–8/27 没有充值的用户。时间区间选 8/1–8/7 → 筛选最近充值在 8/1–8/7 之间，且 8/8–8/27 没有充值的用户。提示：登录/投注不影响流失判定。',
  'member.detail.search.memberAccount': '会员账号',
  'member.detail.search.placeholder': '请输入会员账号/手机/邮箱',
  'member.detail.search.button': '查询',
  'member.detail.search.refresh': '刷新',
  'member.detail.search.notFound': '未找到会员信息',
  'member.detail.search.error': '服务异常',
  'member.detail.tabs.basicInfo': '基本信息',
  'member.detail.tabs.accountInfo': '账户信息',
  'member.detail.tabs.mainAccountTrade': '主账户交易',
  'member.detail.tabs.recentBets': '近七日投注',
  'member.detail.tabs.promotionInfo': '优惠信息',
  'member.detail.tabs.memberPoints': '会员积分',
  'member.detail.tabs.gameAccountTrade': '游戏账户交易',
  'member.detail.tabs.riskControl': '风控信息',
  'member.detail.tabs.badDebt': '坏账记录',
  'member.detail.tabs.regulatoryReport': '游戏线路状态',
  'member.detail.regulatoryReport.statusLabel': '状态',
  'member.detail.regulatoryReport.statusReporting': '上报中',
  'member.detail.regulatoryReport.statusClosed': '已关闭上报',
  'member.detail.regulatoryReport.closeButton': '关闭数据上报',
  'member.detail.regulatoryReport.closeButtonHint': '点击后实时检测前置条件',
  'member.detail.regulatoryReport.precheckTitle': '关闭上报前置校验',
  'member.detail.regulatoryReport.precheckBanner': '系统检测到以下问题，无法执行关闭操作：',
  'member.detail.regulatoryReport.precheckOk': '知道了，稍后重试',
  'member.detail.regulatoryReport.check.deposit.ok': '无待支付充值订单',
  'member.detail.regulatoryReport.check.deposit.fail': '该用户有待支付充值订单，请稍后再试',
  'member.detail.regulatoryReport.check.withdraw.ok': '无待出款提款订单',
  'member.detail.regulatoryReport.check.withdraw.fail': '该用户有待出款提款订单，请稍后再试',
  'member.detail.regulatoryReport.check.unsettledBet.ok': '无待结算投注订单',
  'member.detail.regulatoryReport.check.unsettledBet.fail': '该用户有待结算投注订单，请稍后再试',
  'member.detail.regulatoryReport.check.recentBet.ok': '无在途游戏行为（10分钟内无投注订单）',
  'member.detail.regulatoryReport.check.recentBet.fail': '该用户10分钟内有投注订单，请稍后再试',
  'member.detail.regulatoryReport.ordersDetail': '订单号：{orders}',
  'member.detail.regulatoryReport.reasonTitle': '关闭上报原因',
  'member.detail.regulatoryReport.reasonPlaceholder': '请输入操作原因',
  'member.detail.regulatoryReport.reasonRequired': '请填写关闭原因',
  'member.detail.regulatoryReport.confirmClose': '确认关闭',
  'member.detail.regulatoryReport.applySuccess': '已关闭数据上报',
  'member.detail.regulatoryReport.applyFail': '关闭失败',
  'member.detail.regulatoryReport.precheckFail': '前置校验失败',

  'member.closeReportUser.title': '游戏线路变更记录',
  'member.closeReportUser.subtitle': '仅展示已关闭 PAGCOR 数据上报的用户，支持导出。',
  'member.closeReportUser.memberAccount': '会员账号',
  'member.closeReportUser.memberAccountPh': '会员账号',
  'member.closeReportUser.closeTimeRange': '关闭上报时间',
  'member.closeReportUser.closeTime': '关闭上报时间',
  'member.closeReportUser.operatorName': '操作人',
  'member.closeReportUser.operatorPh': '操作人账号',
  'member.closeReportUser.operationReason': '操作原因',

  'member.reportStatus.detail.title': '上报状态管理',
  'member.reportStatus.detail.currentTitle': '当前状态',
  'member.reportStatus.detail.currentStatus': '当前 report_status',
  'member.reportStatus.detail.latestSwitch': '最近一次切换',
  'member.reportStatus.detail.switchReason': '切换原因',
  'member.reportStatus.detail.toggleBtn': '切换游戏线路',
  'member.reportStatus.detail.historyTitle': '切换历史',
  'member.reportStatus.col.time': '时间',
  'member.reportStatus.col.type': '类型',
  'member.reportStatus.col.statusChange': '状态变化',
  'member.reportStatus.col.operator': '操作人',
  'member.reportStatus.col.reason': '原因',
  'member.reportStatus.col.remark': '备注',
  'member.reportStatus.status.reported': 'A线路',
  'member.reportStatus.status.notReported': 'B线路',
  'member.reportStatus.type.registerAuto': '注册自动',
  'member.reportStatus.type.manual': '手动切换',
  'member.reportStatus.type.autoThreshold': '存款达标',
  'member.reportStatus.type.autoVip': 'VIP达标',
  'member.reportStatus.reasonLabel.REGISTER_AUTO': '注册按比例打标',
  'member.reportStatus.reasonLabel.AUTO_THRESHOLD': '累计存款达标',
  'member.reportStatus.reasonLabel.AUTO_VIP': 'VIP 等级达标',
  'member.reportStatus.modal.title': '切换游戏线路',
  'member.reportStatus.modal.memberAccount': '会员账号',
  'member.reportStatus.modal.statusChange': '状态变化',
  'member.reportStatus.modal.reason': '切换原因',
  'member.reportStatus.modal.remark': '备注',
  'member.reportStatus.modal.remarkPh': '可填写更详细的原因，便于后续审计',
  'member.reportStatus.modal.reasonPh': '必填。请说明切换原因（如：内部测试账号 / 账号回收 / 误接入用户 / 特批用户等）',
  'member.reportStatus.modal.confirm': '确认切换',
  'member.reportStatus.modal.cancel': '取消',
  'member.reportStatus.modal.reasonRequired': '请选择切换原因',
  'member.reportStatus.modal.backupTip': '切换后系统将自动备份该用户当前的 bet_record 至 bet_record_bak（供审计溯源）。下一局游戏开始时立即生效。',
  'member.reportStatus.reason.arbitrage': '套利账号确认',
  'member.reportStatus.reason.channel': '渠道归属冲突',
  'member.reportStatus.reason.internal': '内部测试账号',
  'member.reportStatus.reason.riskUser': '风控用户',
  'member.reportStatus.reason.other': '其他（请填写备注）',
  'member.reportStatus.toggleSuccess': '切换成功',
  'member.reportStatus.toggleFail': '切换失败',
  'member.reportStatus.fetchError': '加载失败',
  'member.reportStatus.list.title': '上报状态管理列表',
  'member.reportStatus.list.subtitle': '注册自动关闭与手动修改的会员均在此展示。',
  'member.reportStatus.list.statusAll': '全部',
  'member.reportStatus.list.memberAccount': '会员账号',
  'member.reportStatus.list.status': '当前状态',
  'member.reportStatus.list.switchTimeRange': '最近切换时间',
  'member.reportStatus.list.switchTime': '最近切换时间',
  'member.reportStatus.list.operator': '操作人',
  'member.reportStatus.list.reason': '切换原因',
  'member.reportStatus.list.detail': '详情',
  'member.reportStatus.list.search': '查询',
  'member.reportStatus.list.reset': '重置',
  'member.reportStatus.list.export': '导出',

  'member.detail.modal.addRemark.title': '添加备注',
  'member.detail.modal.agent.title': '修改上级代理',
  'member.detail.modal.addRemark.content': '备注信息',
  'member.detail.modal.addRemark.placeholder': '请输入备注信息',
  'member.detail.modal.addRemark.isTop': '是否置顶',
  'member.detail.modal.addRemark.success': '备注添加成功',
  'member.detail.modal.addRemark.error': '备注添加失败',
  'member.detail.modal.editEmail.title': '邮箱',
  'member.detail.modal.editEmail.email': '邮箱',
  'member.detail.modal.editEmail.emailPlaceholder': '请输入邮箱',
  'member.detail.modal.editEmail.emailError': '请输入有效的邮箱地址',
  'member.detail.modal.editEmail.remark': '备注',
  'member.detail.modal.editEmail.remarkPlaceholder': '请输入备注',
  'member.detail.modal.editEmail.success': '邮箱修改成功',
  'member.detail.modal.editEmail.error': '邮箱修改失败',
  'member.detail.modal.editEmail.emailExists': '邮箱已被绑定',
  'member.detail.modal.editIdentity.title': '身份信息',
  'member.detail.modal.editIdentity.realName': '真实姓名',
  'member.detail.modal.editIdentity.realNamePlaceholder': '请输入真实姓名',
  'member.detail.modal.editIdentity.birthdayTime': '出生日期',
  'member.detail.modal.editIdentity.remark': '备注',
  'member.detail.modal.editIdentity.remarkPlaceholder': '请输入备注',
  'member.detail.modal.editIdentity.success': '身份信息修改成功',
  'member.detail.modal.editIdentity.error': '身份信息修改失败',
  'member.detail.modal.editKyc.title': '修改KYC信息',
  'member.detail.modal.editKyc.legalName': '法定名称',
  'member.detail.modal.editKyc.legalNamePlaceholder': '请输入法定名称',
  'member.detail.modal.editKyc.birthDate': '出生日期',
  'member.detail.modal.editKyc.idCardUrl': '身份证件',
  'member.detail.modal.editKyc.success': 'KYC信息修改成功',
  'member.detail.modal.editKyc.error': 'KYC信息修改失败',
  'member.detail.modal.editPhone.title': '手机号码',
  'member.detail.modal.editPhone.phoneNumber': '手机号码',
  'member.detail.modal.editPhone.phoneNumberPlaceholder': '请输入手机号码',
  'member.detail.modal.editPhone.phoneNumberError': '请输入有效的手机号码',
  'member.detail.modal.editPhone.remark': '备注',
  'member.detail.modal.editPhone.remarkPlaceholder': '请输入备注',
  'member.detail.modal.editPhone.success': '手机号码修改成功',
  'member.detail.modal.editPhone.error': '手机号码修改失败',
  'member.detail.modal.editPhone.phoneExists': '手机号码已存在',
  'member.detail.modal.editRiskLevel.title': '风控等级',
  'member.detail.modal.editRiskLevel.riskLevel': '风控等级',
  'member.detail.modal.editRiskLevel.riskLevelPlaceholder': '请选择风控等级',
  'member.detail.modal.editRiskLevel.remark': '备注',
  'member.detail.modal.editRiskLevel.remarkPlaceholder': '请输入备注信息',
  'member.detail.modal.editRiskLevel.success': '风控等级修改成功',
  'member.detail.modal.editRiskLevel.error': '修改风控等级失败',
  'member.detail.modal.editRiskLevel.limitLogin': '限制登录',
  'member.detail.modal.editRiskLevel.limitDeposits': '限制存款',
  'member.detail.modal.editRiskLevel.limitWithdrawal': '限制提款',
  'member.detail.modal.editRiskLevel.limitDiscount': '限制领取优惠',
  'member.detail.modal.editRiskLevel.potentialRisk': '疑似风险',
  'member.detail.modal.editRiskLevel.sameIpRisk': '同IP风控',
  'member.detail.modal.editRiskLevel.sameDeviceRisk': '同设备风控',
  'member.detail.modal.editRiskLevel.sameBankCardRisk': '同银行卡风控',
  'member.detail.modal.editRiskLevel.sameWalletRisk': '同钱包风控',
  'member.detail.modal.editRiskLevel.loginLimitType': '登录限制类型',
  'member.detail.modal.editRiskLevel.loginLimitTypePlaceholder': '请选择登录限制类型',
  'member.detail.modal.editRiskLevel.loginLimitTypeRequired': '请选择登录限制类型',
  'member.detail.modal.resetPassword.title': '重置登录密码',
  'member.detail.modal.resetPassword.confirmText': '确认要重置用户密码，重置后用户登录需要用新密码？',
  'member.detail.modal.resetPassword.successTitle': '重置密码成功',
  'member.detail.modal.resetPassword.successText': '重置密码成功，新密码为：',
  'member.detail.modal.resetPassword.okText': '知道了',
  'member.detail.modal.resetPassword.error': '重置登录密码失败',
  'member.detail.modal.resetWithdrawPassword.title': '重置提现密码',
  'member.detail.modal.resetWithdrawPassword.confirmText': '确认要重置用户提款密码吗？',
  'member.detail.modal.resetWithdrawPassword.successTitle': '重置提款密码成功',
  'member.detail.modal.resetWithdrawPassword.successText': '重置提款密码成功，新密码为：',
  'member.detail.modal.resetWithdrawPassword.okText': '知道了',
  'member.detail.modal.resetWithdrawPassword.error': '重置提现密码失败',
  'member.detail.index.summary': '概要信息',
  'member.detail.index.lastLogin': '近10次登录信息',
  'member.detail.index.certification': '认证资料',
  'member.detail.index.vipInfo': 'VIP信息',
  'member.detail.index.manualTags': '用户标签',
  'member.detail.index.remarks': '备注信息',
  'member.detail.basicInfo.memberAccount': '会员账号',
  'member.detail.basicInfo.memberName': '会员昵称',
  'member.detail.basicInfo.agentInviteCode': '代理代码',
  'member.detail.basicInfo.isAppUser': 'APP用户',
  'member.detail.basicInfo.agentName': '直属代理',
  'member.detail.basicInfo.rootInviter': '顶级好友',
  'member.detail.basicInfo.sameAsParentInviter': '同上级好友',
  'member.detail.basicInfo.parentInviter': '上级好友',
  'member.detail.basicInfo.inviterCode': '好友邀请码',
  'member.detail.basicInfo.generateInviterCode': '生成',
  'member.detail.basicInfo.generateInviterCodeSuccess': '好友邀请码生成成功',
  'member.detail.basicInfo.generateInviterCodeFailed': '好友邀请码生成失败',
  'member.detail.basicInfo.riskLevel': '风控等级',
  'member.detail.basicInfo.registerTime': '注册时间',
  'member.detail.basicInfo.registerSource': '注册端',
  'member.detail.basicInfo.limitLogin': '限制登录',
  'member.detail.basicInfo.limitDeposits': '限制存款',
  'member.detail.basicInfo.limitWithdrawal': '限制提款',
  'member.detail.basicInfo.limitDiscount': '限制领取优惠',
  'member.detail.userTypeSetting.title': '用户类型设置',
  'member.detail.userTypeSetting.userType.label': '用户类型',
  'member.detail.userTypeSetting.userType.normal': '普通用户',
  'member.detail.userTypeSetting.userType.store': '实体店用户',
  'member.detail.userTypeSetting.displayVersion.label': '展示版本',
  'member.detail.userTypeSetting.displayVersion.required': '请选择展示版本',
  'member.detail.userTypeSetting.displayVersion.placeholder': '请选择展示版本',
  'member.detail.userTypeSetting.displayVersion.hint': '版本规则由系统预设（见下方映射），此处仅选择用户归属版本。',
  'member.detail.userTypeSetting.version.v1': '版本一（ecasino）',
  'member.detail.userTypeSetting.version.v2': '版本二（ecasino + ebingo）',
  'member.detail.userTypeSetting.offering.egames': 'E-Games',
  'member.detail.userTypeSetting.offering.ebingo': 'E-Bingo',
  'member.detail.userTypeSetting.offering.sportsbook': 'Sportsbook',
  'member.detail.userTypeSetting.offering.traditional': 'Traditional Bingo',
  'member.detail.userTypeSetting.cat.ebingo': 'bingo（除 Bingo Pilipino Live）',
  'member.detail.userTypeSetting.cat.traditional': 'Bingo Pilipino Live (OTB)',
  'member.detail.userTypeSetting.excl.sgPoker': 'sg 的 poker',
  'member.detail.userTypeSetting.excl.sgLive': 'sg 的 livecasino',
  'member.detail.userTypeSetting.excl.none': '无排除项',
  'member.detail.userTypeSetting.preview.includeTitle': '可展示 / 可搜索品类',
  'member.detail.userTypeSetting.preview.excludeTitle': '排除项（不展示 / 搜不到）',
  'member.detail.userTypeSetting.preview.normalNote': '普通用户走线上全量，不做版本过滤；展示版本字段隐藏。',
  'member.detail.userTypeSetting.mapping.name': 'Display Version',
  'member.detail.userTypeSetting.defaultHint': '默认普通用户；存量用户全部默认认为普通用户。',
  'member.detail.userTypeSetting.preview.title': '该用户可见 / 可搜索的游戏品类（预览）',
  'member.detail.userTypeSetting.preview.empty': '请选择展示版本后预览入口范围',
  'member.detail.userTypeSetting.preview.all': '全部品类',
  'member.detail.userTypeSetting.preview.liveNoSg': 'livecasino（不含 sg）',
  'member.detail.userTypeSetting.preview.pokerNoSg': 'poker（不含 sg）',
  'member.detail.userTypeSetting.preview.bingoNoLive': 'bingo（不含 fbm live bingo）',
  'member.detail.userTypeSetting.annot.effect': '变更后「下次登录生效」',
  'member.detail.userTypeSetting.annot.searchCover': '搜索过滤覆盖全部入口',
  'member.detail.userTypeSetting.annot.versionFilter': '后端按 version 过滤',
  'member.detail.userTypeSetting.mapping.title': '版本 ↔ 平台游戏品类映射（系统预设，仅供参考）',
  'member.detail.userTypeSetting.mapping.version': '版本',
  'member.detail.userTypeSetting.mapping.includes': '包含品类',
  'member.detail.userTypeSetting.mapping.excludes': '排除项',
  'member.detail.userTypeSetting.mapping.v1Excludes': '排除 sg 的 poker、livecasino',
  'member.detail.userTypeSetting.mapping.v2Excludes': '排除 sg 的 poker、livecasino；排除 fbm 的 live bingo',
  'member.detail.userTypeSetting.footer.permNote': '入口受角色权限控制',
  'member.detail.userTypeSetting.save': '保存',
  'member.detail.userTypeSetting.success': '用户类型设置成功',
  'member.detail.userTypeSetting.error': '用户类型设置失败',
  'member.detail.kycInfo.realName': '姓名',
  'member.detail.kycInfo.birthDate': '出生日期',
  'member.detail.kycInfo.kycStatus': 'KYC认证',
  'member.detail.kycInfo.email': '邮箱',
  'member.detail.kycInfo.phoneNumber': '手机号',
  'member.detail.kycInfo.mobileProvider': '电信供应商',
  'member.detail.kycInfo.viewPhone': '查看号码',
  'member.detail.kycInfo.viewEmail': '查看邮箱',
  'member.detail.kycInfo.fetchEmailError': '获取邮箱失败',
  'member.detail.kycInfo.mobileValid.verified': '已认证',
  'member.detail.kycInfo.mobileValid.unverified': '未认证',
  'member.detail.kycInfo.emailValid.verified': '已认证',
  'member.detail.kycInfo.emailValid.unverified': '未认证',
  'member.detail.kycInfo.simple.pending': '注册KYC待审核',
  'member.detail.kycInfo..whole.pending': '提款KYC待审核',
  'member.detail.kycInfo.simple.success': '注册KYC成功',
  'member.detail.kycInfo.whole.success': '提款KYC成功',
  'member.detail.kycInfo.simple.failed': '注册KYC失败',
  'member.detail.kycInfo.whole.failed': '提款KYC失败',
  'member.detail.kycInfo.simple.blacklist': '注册KYC黑名单',
  'member.detail.kycInfo.whole.blacklist': '提款KYC黑名单',
  'member.detail.kycInfo.notSubmitted': '未提交',
  'member.detail.vipInfo.upgradeGrow': '(升级)VIP成长值',
  'member.detail.vipInfo.retentionGrow': '(保级)VIP成长值',
  'member.detail.vipInfo.vipLevel': 'VIP等级',
  'member.detail.vipInfo.vipGrow': 'VIP成长值',
  'member.detail.vipInfo.noVipInfo': '暂无VIP信息',
  'member.detail.vipInfo.fetchError': '获取vip信息失败',
  'member.detail.countryArea.error': '获取手机区号失败',
  'member.detail.memberInfo.error': '获取会员信息失败',
  'member.detail.remarkInfo.noMemberSelected': '请先选择会员',
  'member.detail.remarkInfo.remarkContent': '备注内容',
  'member.detail.remarkInfo.isTop': '是否置顶',
  'member.detail.remarkInfo.createTime': '创建时间',
  'member.detail.remarkInfo.createUser': '创建人',
  'member.detail.remarkInfo.operation': '操作',
  'member.detail.remarkInfo.delete': '删除',
  'member.detail.remarkInfo.cancelTop': '取消置顶',
  'member.detail.remarkInfo.setTop': '置顶',
  'member.detail.remarkInfo.confirmDelete': '确定要删除这条备注吗？',
  'member.detail.remarkInfo.confirm': '确定',
  'member.detail.remarkInfo.cancel': '取消',
  'member.detail.remarkInfo.deleteSuccess': '删除备注成功',
  'member.detail.remarkInfo.deleteError': '删除备注失败',
  'member.detail.remarkInfo.topSuccess': '置顶备注成功',
  'member.detail.remarkInfo.cancelTopSuccess': '取消置顶成功',
  'member.detail.remarkInfo.topError': '置顶备注失败',
  'member.detail.remarkInfo.cancelTopError': '取消置顶失败',
  'member.detail.remarkInfo.yes': '是',
  'member.detail.remarkInfo.no': '否',
  'member.detail.common.noData': '暂无数据',
  'member.detail.common.dash': '-',
  'member.betting.columns.index': '序号',
  'member.betting.columns.betTime': '下注时间',
  'member.betting.columns.betAmount': '下注金额',
  'member.betting.columns.winLossAmount': '输赢金额',
  'member.betting.columns.platformCode': '平台名称',
  'member.betting.columns.gameType': '游戏类型',
  'member.betting.gameTypes.1': '电子',
  'member.betting.gameTypes.2': '真人',
  'member.betting.gameTypes.3': '体育',
  'member.betting.gameTypes.4': '彩票',
  'member.betting.gameTypes.5': '捕鱼',
  'member.betting.gameTypes.6': '棋牌',
  'member.betting.gameTypes.7': '3D厅',
  'member.betting.gameTypes.10': '电竞',
  'member.betting.gameTypes.12': '宾果',
  'member.betting.currentPageTotal': '当页累计',
  'member.welfare.columns.claimTime': '到账时间',
  'member.welfare.columns.promotionName': '优惠名称',
  'member.welfare.columns.promotionAmount': '优惠金额',
  'member.welfare.columns.promotionTemplate': '优惠模板',
  'member.welfare.columns.sender': '发放人',
  'member.welfare.columns.status': '状态',
  'member.welfare.status.0': '待领取',
  'member.welfare.status.1': '已完成',
  'member.welfare.status.2': '已过期',
  'member.trade.columns.transactionTime': '交易时间',
  'member.trade.columns.type': '类型',
  'member.trade.columns.details': '详情',
  'member.trade.columns.beforeAmount': '交易前金额',
  'member.trade.columns.amount': '交易金额',
  'member.trade.columns.afterAmount': '交易后金额',
  'member.trade.columns.operator': '操作人',
  'member.trade.types.1001': '充值',
  'member.trade.types.1002': '提现',
  'member.trade.types.3999': '人工发放优惠',
  'member.trade.types.3001': 'VIP升级礼金',
  'member.trade.types.3002': 'VIP保级礼金',
  'member.trade.types.3003': 'VIP周俸禄',
  'member.trade.types.3004': 'VIP月俸禄',
  'member.trade.types.3005': 'VIP生日礼金',
  'member.trade.types.3006': 'VIP升级积分',
  'member.trade.types.3007': 'VIP保级积分',
  'member.trade.types.3008': 'VIPapp每日积分',
  'member.trade.types.3009': 'VIPh5每日积分',
  'member.trade.types.3010': 'VIP游戏返水奖励',
  'member.trade.types.3011': '返水奖励',
  'member.trade.types.3012': '注册奖励',
  'member.trade.types.3013': '存款优惠',
  'member.trade.types.3014': '每日首存优惠',
  'member.trade.types.3015': '登入',
  'member.trade.types.3016': '充值',
  'member.trade.types.3017': '兑换码优惠',
  'member.trade.types.3018': '大转盘奖励',
  'member.trade.types.3019': '笔笔存优惠',
  'member.trade.types.3030': '首存优惠',
  'member.trade.types.3031': '排行榜活动奖励',
  'member.trade.types.3020': '邀请奖励',
  'member.trade.types.3021': '成就奖励',
  'member.trade.types.3022': '被邀请奖励',
  'member.trade.types.3023': '信息绑定优惠',
  'member.trade.types.3024': '宝箱奖励',
  'member.trade.types.3026': '红包雨',
  'member.trade.types.3028': '宝箱彩金',
  'member.trade.types.3029': '新返水优惠',
  'member.trade.types.3032': '邀请充值返佣',
  'member.trade.types.3033': '邀请投注返佣',
  'member.trade.types.3034': '邀请输赢返佣',
  'member.trade.types.3035': '邀请NGR返佣',
  'member.trade.types.5001': '人工存入',
  'member.trade.types.5002': '人工转出',
  'member.trade.types.5003': '人工存入不计入存提',
  'member.trade.types.5004': '人工转出不计入存提',
  'member.trade.types.5005': '坏账清账',
  'member.trade.types.5006': '代理存入',
  'member.trade.types.5007': '代理转出',
  'member.trade.types.6001': '游戏转入',
  'member.trade.types.6002': '游戏转出',
  'member.trade.types.7001': '积分兑换',
  'member.trade.types.9001': '充值加油',
  'member.trade.types.9002': '邀请加油',
  'member.trade.types.9003': '入场奖励',
  'member.trade.types.9004': '闯关奖励',
  'member.trade.types.9005': '积分兑换推进货币',
  'member.trade.types.OTHER': '其他',
  'member.point.columns.changeDate': '积分变动日期',
  'member.point.columns.changeType': '积分变动类型',
  'member.point.columns.beforePoints': '变动前积分',
  'member.point.columns.changeAmount': '积分变动数量',
  'member.point.columns.afterPoints': '变动后积分',
  'member.point.columns.remark': '备注',
  'member.point.changeTypes.increase': '增加',
  'member.point.changeTypes.decrease': '减少',
  'member.point.manualAdjust.title': '人工调整积分',
  'member.point.manualAdjust.currentPoints': '会员积分',
  'member.point.manualAdjust.adjustType': '调整类型',
  'member.point.manualAdjust.adjustPoints': '调整会员积分',
  'member.point.manualAdjust.validDate': '积分有效期',
  'member.point.manualAdjust.submitRemark': '提交备注',
  'member.point.manualAdjust.increasePoints': '增加会员积分',
  'member.point.manualAdjust.decreasePoints': '减少会员积分',
  'member.point.manualAdjust.placeholder': '请输入',
  'member.point.manualAdjust.success': '积分调整成功',
  'member.point.manualAdjust.error': '积分调整失败',
  'member.point.manualAdjust.getPointsError': '获取会员积分失败',
  'wallet.accountBalance.title': '账户钱包',
  'wallet.accountBalance.totalBalance': '总余额',
  'wallet.accountBalance.mainBalance': '主账户',
  'wallet.accountBalance.memberPoints': '会员积分',
  'wallet.accountBalance.noPlatformData': '暂无平台数据',
  'wallet.accountBalance.manualAdjust.title': '手工调账',
  'wallet.accountBalance.manualAdjust.currency': '选择货币',
  'wallet.accountBalance.manualAdjust.currencyPlaceholder': '请选择货币',
  'wallet.accountBalance.manualAdjust.adjustType': '调整类型',
  'wallet.accountBalance.manualAdjust.adjustTypePlaceholder': '请选择调整类型',
  'wallet.accountBalance.manualAdjust.increaseAmount': '增加金额',
  'wallet.accountBalance.manualAdjust.decreaseAmount': '减少金额',
  'wallet.accountBalance.manualAdjust.amount': '调整金额',
  'wallet.accountBalance.manualAdjust.amountPlaceholder': '请输入调整金额',
  'wallet.accountBalance.manualAdjust.increaseFlow': '增加流水金额',
  'wallet.accountBalance.manualAdjust.decreaseFlow': '减少流水金额',
  'wallet.accountBalance.manualAdjust.flowPlaceholder': '请输入流水金额',
  'wallet.accountBalance.manualAdjust.memoPayDeposit': '计入存提',
  // —— 扣款退回额度 ——
  'wallet.accountBalance.manualAdjust.refund.label': '额度处理',
  'wallet.accountBalance.manualAdjust.refund.checkbox': '是否退回额度',
  'wallet.accountBalance.manualAdjust.refund.hint': '默认未退（扣款全部归回平台）。勾选后由运营手动分摊每个来源退回金额，每行 ≤ 参考可退余额、加总 ≤ 扣减总金额，差额归平台。',
  'wallet.accountBalance.manualAdjust.refund.detailTitle': '退回明细',
  'wallet.accountBalance.manualAdjust.refund.colSource': '来源',
  'wallet.accountBalance.manualAdjust.refund.colRefundable': '参考可退余额',
  'wallet.accountBalance.manualAdjust.refund.colAlreadyRefunded': '已退',
  'wallet.accountBalance.manualAdjust.refund.colRefund': '本次退回',
  'wallet.accountBalance.manualAdjust.refund.totalRefund': '退回总金额',
  'wallet.accountBalance.manualAdjust.refund.totalDeduct': '扣减总金额',
  'wallet.accountBalance.manualAdjust.refund.platformResidual': '差额（归平台）',
  'wallet.accountBalance.manualAdjust.refund.sourceOpUser': '后台账号',
  'wallet.accountBalance.manualAdjust.refund.sourceOpUserPlaceholder': '后台账号用户调账额度',
  'wallet.accountBalance.manualAdjust.refund.sourceL1': '一级代理',
  'wallet.accountBalance.manualAdjust.refund.sourceL2': '二级代理',
  'wallet.accountBalance.manualAdjust.refund.empty': '该会员该币种暂无可退来源',
  'wallet.accountBalance.manualAdjust.refund.errorRowExceed': '⚠ 某行退回金额超过该来源的参考可退余额',
  'wallet.accountBalance.manualAdjust.refund.errorSumExceed': '⚠ 退回总金额超过扣减总金额',
  'wallet.accountBalance.manualAdjust.refund.fetchFail': '加载可退来源失败',
  'wallet.accountBalance.manualAdjust.remark': '提交备注',
  'wallet.accountBalance.manualAdjust.remarkPlaceholder': '请输入备注说明',
  'wallet.accountBalance.manualAdjust.confirm': '确认调整',
  'wallet.accountBalance.manualAdjust.cancel': '取消',
  'wallet.accountBalance.manualAdjust.success': '调整成功',
  'wallet.accountBalance.manualAdjust.error': '调整失败',
  'wallet.bankCards.title': '银行卡',
  'wallet.bankCards.bindTime': '绑定时间',
  'wallet.bankCards.bankName': '银行名称',
  'wallet.bankCards.cardHolder': '持卡人姓名',
  'wallet.bankCards.cardNumber': '银行卡号',
  'wallet.bankCards.status': '状态',
  'wallet.bankCards.enabled': '启用',
  'wallet.bankCards.disabled': '禁用',
  'wallet.bankCards.actions.unbind': '解绑',
  'wallet.bankCards.actions.enable': '启用',
  'wallet.bankCards.actions.disable': '禁用',
  'wallet.bankCards.actions.confirmUnbind': '确认解绑',
  'wallet.bankCards.actions.confirmUnbindContent': '确定要解绑该银行卡吗？',
  'wallet.bankCards.actions.confirmEnable': '确认启用',
  'wallet.bankCards.actions.confirmEnableContent': '确定要启用该银行卡吗？',
  'wallet.bankCards.actions.confirmDisable': '确认禁用',
  'wallet.bankCards.actions.confirmDisableContent': '确定要禁用该银行卡吗？',
  'wallet.bankCards.actions.unbindSuccess': '解绑成功',
  'wallet.bankCards.actions.unbindError': '解绑失败',
  'wallet.bankCards.actions.enableSuccess': '启用成功',
  'wallet.bankCards.actions.enableError': '启用失败',
  'wallet.bankCards.actions.disableSuccess': '禁用成功',
  'wallet.bankCards.actions.disableError': '禁用失败',
  'wallet.financialOverview.title': '资金概况',
  'wallet.financialOverview.totalDeposit': '存款总额',
  'wallet.financialOverview.totalWithdrawal': '取款总额',
  'wallet.financialOverview.firstDeposit': '首存',
  'wallet.financialOverview.depositCount': '存款次数',
  'wallet.financialOverview.withdrawalCount': '取款次数',
  'wallet.financialOverview.totalBonus': '总优惠金额',
  'wallet.financialOverview.firstDepositTime': '首存时间',
  'wallet.financialOverview.lastDeposit': '最近一笔存款',
  'wallet.financialOverview.lastDepositTime': '最近一笔存款时间',
  'wallet.financialOverview.historicalProfitLoss': '历史盈亏',
  'wallet.financialOverview.historicalProfitLossDesc1': '历史盈亏: 统计昨日之前的所有三方盈亏数据。',
  'wallet.financialOverview.historicalProfitLossDesc2': '金额颜色 (与近七日投注的颜色逻辑一致)。',
  'wallet.financialOverview.historicalProfitLossDesc3': '红色: 输, 绿色: 盈。',
  'wallet.financialOverview.totalBetFlowAmount': '总有效流水',
  'wallet.financialOverview.pointExchangeAmount': '积分兑换金额',
  'wallet.financialOverview.todayDepositAmount': '当天存款金额',
  'wallet.financialOverview.todayWithdrawAmount': '当天提款金额',
  'wallet.financialOverview.todayProfitAmount': '当天盈利',
  'wallet.financialOverview.todayBetAmount': '当天投注',
  'wallet.financialOverview.todayBonusAmount': '当天彩金（含兑换）',
  'wallet.financialOverview.fetchError': '获取资金概况失败',
  'wallet.financialOverview.historicalProfitLossFetchError': '获取历史盈亏失败',
  'wallet.walletAccounts.title': '钱包信息',
  'wallet.walletAccounts.bindTime': '绑定时间',
  'wallet.walletAccounts.walletType': '钱包类型',
  'wallet.walletAccounts.walletName': '钱包名称',
  'wallet.walletAccounts.walletAccount': '钱包账号',
  'wallet.walletAccounts.usdtType': 'usdt链类型',
  'wallet.walletAccounts.status': '状态',
  'wallet.walletAccounts.enabled': '启用',
  'wallet.walletAccounts.disabled': '禁用',
  'wallet.walletAccounts.actions.unbind': '解绑',
  'wallet.walletAccounts.actions.enable': '启用',
  'wallet.walletAccounts.actions.disable': '禁用',
  'wallet.walletAccounts.actions.confirmUnbind': '确认解绑',
  'wallet.walletAccounts.actions.confirmUnbindContent': '确定要解绑该钱包账户吗？',
  'wallet.walletAccounts.actions.confirmEnable': '确认启用',
  'wallet.walletAccounts.actions.confirmEnableContent': '确定要启用该钱包账户吗？',
  'wallet.walletAccounts.actions.confirmDisable': '确认禁用',
  'wallet.walletAccounts.actions.confirmDisableContent': '确定要禁用该钱包账户吗？',
  'wallet.walletAccounts.actions.unbindSuccess': '解绑成功',
  'wallet.walletAccounts.actions.unbindError': '解绑失败',
  'wallet.walletAccounts.actions.statusUpdateSuccess': '状态更新成功',
  'wallet.walletAccounts.actions.statusUpdateError': '状态更新失败',
  'wallet.withdrawalHistory.title': '提现流水信息',
  'wallet.withdrawalHistory.remainingFlow': '尚需流水',
  'wallet.withdrawalHistory.completedFlow': '已完成流水',
  'wallet.withdrawalHistory.totalFlow': '总流水要求',
  'wallet.withdrawalHistory.manualAdjust.title': '尚需流水-人工调整',
  'wallet.withdrawalHistory.manualAdjust.currency': '选择货币',
  'wallet.withdrawalHistory.manualAdjust.currencyPlaceholder': '请选择货币',
  'wallet.withdrawalHistory.manualAdjust.adjustType': '调整类型',
  'wallet.withdrawalHistory.manualAdjust.adjustTypePlaceholder': '请选择调整类型',
  'wallet.withdrawalHistory.manualAdjust.increaseFlow': '增加流水',
  'wallet.withdrawalHistory.manualAdjust.decreaseFlow': '减少流水',
  'wallet.withdrawalHistory.manualAdjust.amount': '调整数量',
  'wallet.withdrawalHistory.manualAdjust.amountPlaceholder': '请输入调整数量',
  'wallet.withdrawalHistory.manualAdjust.remark': '提交备注',
  'wallet.withdrawalHistory.manualAdjust.remarkPlaceholder': '请输入备注说明',
  'wallet.withdrawalHistory.manualAdjust.confirm': '确认调整',
  'wallet.withdrawalHistory.manualAdjust.cancel': '取消',
  'wallet.withdrawalHistory.manualAdjust.success': '调整成功',
  'wallet.withdrawalHistory.manualAdjust.error': '调整失败',
  'wallet.withdrawalHistory.flowChange.title': '会员流水账变记录',
  'wallet.withdrawalHistory.flowChange.operationTime': '操作时间',
  'wallet.withdrawalHistory.flowChange.type': '类型',
  'wallet.withdrawalHistory.flowChange.totalCompletedFlow': '总已完成流水',
  'wallet.withdrawalHistory.flowChange.beforeFlow': '总流水变动前',
  'wallet.withdrawalHistory.flowChange.flowChange': '变动流水',
  'wallet.withdrawalHistory.flowChange.afterFlow': '总流水变动后',
  'wallet.withdrawalHistory.flowChange.types.recharge': '充值',
  'wallet.withdrawalHistory.flowChange.types.withdraw': '提现',
  'wallet.withdrawalHistory.flowChange.types.bonus': '红利',
  'wallet.withdrawalHistory.flowChange.types.rebate': '返水',
  'wallet.withdrawalHistory.flowChange.types.manual': '人工',
  'wallet.withdrawalHistory.flowChange.types.game': '游戏账变',
  'wallet.withdrawalHistory.flowChange.types.point': '积分兑换',
  'wallet.withdrawalHistory.flowChange.types.unknown': '未知类型',
  'wallet.common.refresh': '刷新',
  'wallet.common.takeBack': '取回',
  'wallet.common.manualAdjust': '手动调账',
  'wallet.common.confirm': '确认',
  'wallet.common.cancel': '取消',
  'wallet.common.success': '成功',
  'wallet.common.error': '失败',
  'wallet.common.loading': '加载中...',
  'wallet.common.switchTabToLoad': '切换到该选项卡以加载内容',
  'wallet.common.searchMember': '请在上方搜索框输入会员账号进行查询',
  'wallet.common.operations': '操作',
  'wallet.common.takeBackConfirm': '请确认是否取回到账户余额中？',
  'wallet.common.takeBackWarning': '确定后将批量取回，请稍候查看账户余额。',
  'wallet.withdrawalHistory.flowExceedError': '调整流水不能大于尚需流水',
  'member.detail.vipInfo.permanentRetention': '永久保级',
  'member.detail.modal.agent.currentAgent': '当前上级代理：',
  'member.detail.modal.agent.operationType': '选择操作类型：',
  'member.detail.modal.agent.modifyAgent': '修改上级代理',
  'member.detail.modal.agent.removeAgent': '移除上级代理',
  'member.detail.modal.agent.targetAgent': '指定代理：',
  'member.detail.modal.agent.remark': '备注信息：',
  'member.detail.modal.agent.cancel': '取消',
  'member.detail.modal.agent.confirm': '确认',
  'member.detail.modal.agent.inputPlaceholder': '请输入',
  'member.detail.modal.agent.agentNotExist': '指定代理名称不存在！',
  'member.detail.modal.agent.inputAgentAccount': '请输入代理账号',
  'member.detail.modal.agent.success': '操作成功',
  'member.detail.modal.agent.error': '操作失败',
  'member.detail.modal.inviter.title': '新增邀请人',
  'member.detail.modal.inviter.currentInviter': '当前邀请人：',
  'member.detail.modal.inviter.operationType': '选择操作类型：',
  'member.detail.modal.inviter.selectOperationType': '请选择操作类型',
  'member.detail.modal.inviter.modifyInviter': '修改邀请人',
  'member.detail.modal.inviter.removeInviter': '移除邀请人',
  'member.detail.modal.inviter.targetInviter': '指定邀请人：',
  'member.detail.modal.inviter.inputInviterAccount': '请输入邀请人账号',
  'member.detail.modal.inviter.inputPlaceholder': '请输入',
  'member.detail.modal.inviter.inputHint': '可输入邀请人账号/UID',
  'member.detail.modal.inviter.remark': '备注信息：',
  'member.detail.modal.inviter.cancel': '取消',
  'member.detail.modal.inviter.confirm': '确认',
  'member.detail.modal.inviter.success': '操作成功',
  'member.detail.modal.inviter.error': '操作失败',
  'member.detail.modal.inviter.inviterNotExist': '邀请人不存在',
  'member.detail.modal.inviter.noInviter': '无邀请人',
  'member.gameAccountTrade.columns.transId': '交易订单号',
  'member.gameAccountTrade.columns.platformCode': '游戏平台',
  'member.gameAccountTrade.columns.gameType': '游戏类型',
  'member.gameAccountTrade.columns.gameName': '游戏名称',
  'member.gameAccountTrade.columns.gameCode': '游戏编码',
  'member.gameAccountTrade.columns.eventTime': '下注时间',
  'member.gameAccountTrade.columns.createTime': '账变时间',
  'member.gameAccountTrade.columns.before': '交易前金额',
  'member.gameAccountTrade.columns.amount': '交易金额',
  'member.gameAccountTrade.columns.balance': '交易后金额',
  'member.gameAccountTrade.columns.action': '交易接口',
  'member.gameAccountTrade.columns.status': '状态',
  'member.gameAccountTrade.status.success': '成功',
  'member.gameAccountTrade.status.refund': '成功退款',
  'member.gameAccountTrade.search.platformPlaceholder': '全部平台',
  'member.gameAccountTrade.search.platformAll': '全部平台',
  'member.gameAccountTrade.search.last7Days': '近七天',
  'member.gameAccountTrade.search.thisMonth': '本月',
  'member.gameAccountTrade.gameTypes.1': '电子',
  'member.gameAccountTrade.gameTypes.2': '真人',
  'member.gameAccountTrade.gameTypes.3': '体育',
  'member.gameAccountTrade.gameTypes.4': '彩票',
  'member.gameAccountTrade.gameTypes.5': '捕鱼',
  'member.gameAccountTrade.gameTypes.6': '棋牌',
  'member.gameAccountTrade.gameTypes.7': '3D厅',
  'member.gameAccountTrade.search.gameType': '游戏类型',
  'member.gameAccountTrade.search.gamePlatform': '游戏平台',
  'member.gameAccountTrade.search.accountChangeTime': '账变时间',
  'member.gameAccountTrade.search.betTime': '下注时间',
  'member.gameAccountTrade.search.betStartTime': '下注开始时间',
  'member.gameAccountTrade.search.betEndTime': '下注结束时间',
  'member.gameAccountTrade.validation.betTimeExceedError': '下注时间范围不能超过账变时间范围！',
  'member.gameAccountTrade.error.fetchFailed': '获取游戏账户交易失败:',
  'member.gameAccountTrade.validation.dateRangeExceedError': '账变时间范围不能超过7天！',

  // 会员列表页面
  'memberList.title': '会员列表',
  'memberList.searchWarning': '由于数据量大，请关联1个条件或以上一起组合查询数据',
  'memberList.exportWarning': '请至少选择3个查询条件再导出',
  'memberList.timeConditionWarning': '选择首充时间或最近充值时间时，请同时选择币种',
  'memberList.dataExceedWarning': '你查询的数据已超出1000条，请使用导出功能导出你所需要的数据',
  'memberList.exportExceedWarning': '您导出的数据已超出10000条，请调整筛选条件',
  'memberList.notes': '页面进来默认没数据，表格则显示暂无数据',
  'memberList.defaultEmpty': '暂无数据',
  'memberList.registerTime': '注册时间',
  'memberList.firstRechargeTime': '首充时间',
  'memberList.lastRechargeTime': '最近充值时间',
  'memberList.lastLoginTime': '最后登录时间',
  'memberList.mobileProvider': '电信供应商',
  'memberList.mobileProviderPlaceholder': '请选择电信供应商',
  'memberList.mobileValid': '手机号是否已认证',
  'memberList.mobileValidPlaceholder': '请选择手机号认证状态',
  'memberList.mobileValid.verified': '已验证',
  'memberList.mobileValid.unverified': '未验证',
  'memberList.isAgent': '是否有上级代理',
  'memberList.hasAgent': '有上级代理',
  'memberList.noAgent': '无上级代理',
  'memberList.agentAccount': '代理账号',
  'memberList.agentType': '代理类型',
  'memberList.agentTag': '代理标签',
  'memberList.topAgent': '一级代理',
  'memberList.agentAccountAllUnderL1': '该L1下全部',
  'memberList.agentAccountSelectL1First': '请先选择一级代理',
  'memberList.defaultAgent': '默认代理',
  'memberList.realName': '会员真实姓名',
  'memberList.memberAccount': '会员账号',
  'memberList.memberName': '会员昵称',
  'memberList.vipLevels': 'VIP等级',
  'memberList.validInfos': '认证信息',
  'memberList.risks': '风控等级',
  'memberList.manualTags': '手动标签',
  'memberList.manualTagsPlaceholder': '请选择用户标签',
  'memberList.autoTags': '自动标签',
  'memberList.userTags': '用户标签',
  'memberList.userTagsPlaceholder': '请选择用户标签',
  'memberList.loginLimit': '限制登录',
  'memberList.loginLimitType': '登录限制类型',
  'memberList.loginLimitTypePlaceholder': '请选择登录限制类型',
  'memberList.loginLimitType.passwordError': '登录密码错误',
  'memberList.vipLevel': '会员等级',
  'memberList.registerInfo': '注册信息',
  'memberList.registerIp': '注册IP',
  'memberList.mainBalance': '主账户余额',
  'memberList.rechargeCount': '充值次数',
  'memberList.withdrawCount': '提现次数',
  'memberList.totalRecharge': '总充值',
  'memberList.totalWithdraw': '总提现',
  'memberList.validInfo': '认证信息',
  'memberList.memberPoints': '会员积分',
  'memberList.riskLevel': '风控等级',
  'memberList.currency': '币种',
  'memberList.startDate': '开始日期',
  'memberList.endDate': '结束日期',
  'memberList.search': '查询',
  'memberList.reset': '重置',
  'memberList.export': '导出',
  'memberList.export.loading': '导出中...',
  'memberList.export.success': '导出成功',
  'memberList.requestFailed': '请求失败',
  'memberList.action': '操作',
  'memberList.view': '查看',
  'memberList.batchSetRisk': '批量设置风控',
  'memberList.noData': '暂无数据',
  'memberList.upload.selected': '清选择文件',
  'memberList.upload.running': '正在上传中',
  'memberList.upload.success': '上传成功',
  'memberList.upload.failed': '上传失败',
  'memberList.upload.file.size': '文件不能超過 2GB',
  'memberList.upload.title': '上传会员信息 CSV',
  'memberList.upload.selected.area': '点击或拖拽文件到此区域上传',
  'memberList.upload.selected.area.bottom': '仅支持 CSV 文件，大小不超过 40MB，字段名需符合服务端要求，表头列名如：username, date_of_birth, user_type, version, ...；user_type 支持 NORMAL / STORE，实体店用户需填写 version：V1 / V2。',
  'memberList.upload.button': '上传',

  // 认证信息选项
  'memberList.validInfo.realName': '实名认证',
  'memberList.validInfo.mobile': '手机认证',
  'memberList.validInfo.email': '邮箱认证',
  'memberList.validInfo.kyc': 'KYC认证',

  // 认证信息标签
  'memberList.validInfo.realNameTag': '实名',
  'memberList.validInfo.mobileTag': '手机',
  'memberList.validInfo.emailTag': '邮箱',
  'memberList.validInfo.kycTag': 'KYC',
  'memberList.validInfo.verification': '认证',

  // 风控等级选项
  'memberList.riskLevel.limitLogin': '限制登入',
  'memberList.riskLevel.limitDeposit': '限制存款',
  'memberList.riskLevel.limitWithdraw': '限制提款',
  'memberList.riskLevel.limitBonus': '限制领取优惠',
  'memberList.riskLevel.suspiciousRisk': '疑似风险',
  'memberList.riskLevel.normal': '正常',
  'memberList.riskLevel.sameIpRisk': '同IP风控',
  'memberList.riskLevel.sameDeviceRisk': '同设备风控',
  'memberList.riskLevel.sameBankCardRisk': '同银行卡风控',
  'memberList.riskLevel.sameWalletRisk': '同钱包风控',

  // 快捷日期选项
  'memberList.quickDate.today': '今天',
  'memberList.quickDate.yesterday': '昨天',
  'memberList.quickDate.last7Days': '最近7天',
  'memberList.quickDate.last30Days': '最近30天',
  'memberList.quickDate.thisWeek': '本周',
  'memberList.quickDate.lastWeek': '上周',
  'memberList.quickDate.thisMonth': '本月',
  'memberList.quickDate.lastMonth': '上月',

  // 登录终端选项
  'memberList.loginChannel.label': '登录终端',
  'memberList.loginChannel.placeholder': '请选择登录终端',
  'memberList.loginChannel.all': '全部',
  'memberList.loginChannel.others': '其他',
  'memberList.loginChannel.web': 'Web',
  'memberList.loginChannel.androidApp': 'Android APP',
  'memberList.loginChannel.androidH5': 'Android H5',
  'memberList.loginChannel.androidPwa': 'Android PWA',
  'memberList.loginChannel.iosH5': 'iOS H5',
  'memberList.loginChannel.iosPwa': 'iOS PWA',
  'memberList.loginChannel.iosApp': 'IOS APP',

  // 单位
  'memberList.unit.times': '次',

  // 注册未充值列表页面
  'memberNoRecharge.title': '注册未充值列表',
  'memberNoRecharge.registerTime': '注册时间',
  'memberNoRecharge.memberAccount': '会员账号',
  'memberNoRecharge.memberLevel': '会员等级',
  'memberNoRecharge.agentAccount': '上级代理账号',
  'memberNoRecharge.registerInfo': '注册信息',
  'memberNoRecharge.registerTimeLabel': '注册时间',
  'memberNoRecharge.registerIp': '注册IP',
  'memberNoRecharge.rechargeCount': '充值次数',
  'memberNoRecharge.withdrawCount': '提现次数',
  'memberNoRecharge.totalRecharge': '总充值',
  'memberNoRecharge.totalWithdraw': '总提现',
  'memberNoRecharge.firstRechargeTime': '首充时间',
  'memberNoRecharge.action': '操作',
  'memberNoRecharge.view': '查看',
  'memberNoRecharge.query': '查询',
  'memberNoRecharge.reset': '重置',
  'memberNoRecharge.export': '导出',
  'memberNoRecharge.startDate': '开始日期',
  'memberNoRecharge.endDate': '结束日期',
  'memberNoRecharge.selectTimeRange': '请选择时间范围或等待数据加载',
  'memberNoRecharge.exportingData': '正在导出数据...',
  'memberNoRecharge.exportSuccess': '导出成功',
  'memberNoRecharge.exportFailed': '导出失败',
  'memberNoRecharge.requestFailed': '请求失败',
  'memberNoRecharge.selectTimeRangeRequired': '请选择注册时间范围',

  // 会员流失列表页面额外字段
  'memberChurn.accountLabel': '账号',
  'memberChurn.nameLabel': '姓名',
  'memberChurn.nicknameLabel': '昵称',
  'memberChurn.registerTimeLabel': '注册时间',
  'memberChurn.registerIpLabel': '注册IP',
  'memberChurn.lastRechargeTimeLabel': '最后充值时间',
  'memberChurn.caliberExplanation.title': '流失口径说明',
  'memberChurn.caliberExplanation.rule1': '筛选说明（最近一次行为时间）',
  'memberChurn.caliberExplanation.rule2': '• 可单独或组合筛选：最近充值 / 最近登录 / 最近投注（均为用户"最近一次"行为时间）。',
  'memberChurn.caliberExplanation.rule3': '• 时间用法：',
  'memberChurn.caliberExplanation.rule4': '– 只填"结束" ⇒ 查最近一次 ≤ 该日期；',
  'memberChurn.caliberExplanation.rule5': '– 只填"开始" ⇒ 查最近一次 ≥ 该日期（近期仍活跃）；',
  'memberChurn.caliberExplanation.rule6': '– 填"开始+结束" ⇒ 查最近一次落在该区间。',
  'memberChurn.caliberExplanation.rule7': '单口径示例',
  'memberChurn.caliberExplanation.example1': '– 今天 9/27，充值结束=9/24 ⇒ 最近一次充值 ≤ 9/24 的用户；',
  'memberChurn.caliberExplanation.example2': '– 登录区间 8/1–8/7 ⇒ 最近一次登录在 8/1–8/7 的用户；',
  'memberChurn.caliberExplanation.example3': '– 投注只填开始=9/01 ⇒ 最近一次投注 ≥ 9/01 的用户。',
  'memberChurn.caliberExplanation.rule8': '组合用法（回答不同业务问题）',
  'memberChurn.caliberExplanation.example4': '– 充值 AND 登录：充值后有没有回访？（例：lastDep 在 8 月，lastLogin 是否进入 9 月）',
  'memberChurn.caliberExplanation.example5': '– 充值 AND 投注：充值后有没有真实消费？（例：lastDep 新，但 lastBet 旧 → 只充不玩）',
  'memberChurn.caliberExplanation.example6': '– 登录 AND 投注：回来是否下注？（例：lastLogin 新、lastBet 旧 → 访问留存好，消费留存差）',
  'memberChurn.caliberExplanation.example7': '– 充值 AND 登录 AND 投注：三者都新 = 高价值活跃用户；任一老 = 针对性召回。',
  'memberChurn.lastLoginStartTime': '最后登入时间开始',
  'memberChurn.lastLoginEndTime': '最后登入时间结束',
  'memberChurn.lastBettingStartTime': '最后投注时间开始',
  'memberChurn.lastBettingEndTime': '最后投注时间结束',

  // KycRecordAdd.tsx
  'member.detail.modal.addKyc.title': '编辑KYC',
  'kyc.add.form.basic.information': '基本信息',
  'kyc.add.form.fullName': '全名',
  'kyc.add.form.firstName': '名字',
  'kyc.add.form.middleName': '中间名',
  'kyc.add.form.lastName': '姓',
  'kyc.add.form.birth.date': '出生日期',
  'kyc.add.form.upload.id': '上传证件照片',
  'kyc.add.form.upload.selfie': '上传手持证件自拍',
  'kyc.add.form.additional.information': '附加信息',
  'kyc.add.form.birth.place': '出生地',
  'kyc.add.form.permanent.address': '永久地址',
  'kyc.add.form.current.address': '现地址',
  'kyc.add.form.nationality': '国籍',
  'kyc.add.form.income.source': '来源收入证明',
  'kyc.add.form.work.nature': '工作性质',
  'kyc.add.form.upload.latest': '最新照片',

  // 沉默用户列表
  'memberSilent.title': '沉默用户列表',
  'memberSilent.noDepositDate': '未存款日期',
  'memberSilent.noDepositDateTip': '最近一次充值早于此日期或为空，即判定为"沉默用户"',
  'memberSilent.noDepositDateDescription': '"未存款日期"代表基准日期；"沉默"= 最近一次充值早于此日期或为空。勾选"是否今日进入沉默"时：当选择历史日期，"今日"指该日期当天；如需与短信任务一致，请选择"最近N天（截止今天）"。',
  'memberSilent.selectDate': '选择日期',
  'memberSilent.selectNoDepositDate': '请选择未存款日期',
  'memberSilent.selectNoDepositDateRequired': '未存款日期为必填项',
  'memberSilent.isTodayEnterSilent': '是否今日进入沉默',
  'memberSilent.isTodayEnterSilentTip': '勾选后仅看"今日进入沉默"的用户；如选择历史日期，"今日"=该日期当天',
  'memberSilent.requireLogin': '要求区间内有登录',
  'memberSilent.loginStart': '登录开始时间',
  'memberSilent.loginEnd': '登录结束时间',
  'memberSilent.requireBetting': '要求区间内有投注',
  'memberSilent.bettingStart': '投注开始时间',
  'memberSilent.bettingEnd': '投注结束时间',
  'memberSilent.vipLevels': 'VIP等级',
  'memberSilent.selectVipLevels': '请选择VIP等级',
  'memberSilent.selectAllVip': '全选',
  'memberSilent.excludeOfficialUsers': '排除官网用户',
  'memberSilent.excludeAllAgents': '排除全部代理',
  'memberSilent.excludeAgentIds': '排除指定代理',
  'memberSilent.selectExcludeAgents': '选择要排除的代理（可搜索，可多选）',
  'memberSilent.query': '查询',
  'memberSilent.reset': '重置',
  'memberSilent.export': '导出',
  'memberSilent.exportingData': '正在导出数据...',
  'memberSilent.exportSuccess': '导出成功',
  'memberSilent.exportFailed': '导出失败',
  'memberSilent.requestFailed': '请求失败',
  'memberSilent.lastLoginTime': '最近登录时间',
  'memberSilent.currencyRequired': '请选择币种',
  'memberSilent.lastRechargeTime': '最近充值时间',
  'memberSilent.lastBettingTime': '最近投注时间',
  'memberSilent.totalRecharge': '累计充值（多币种）',
  'memberSilent.tip': '提示',

  // 风控信息
  'member.detail.riskControl.sameIpUsers': '同ip用户',
  'member.detail.riskControl.sameDeviceUsers': '同设备用户',
  'member.detail.riskControl.sameBankCardUsers': '同绑卡用户',
  'member.detail.riskControl.sameWalletUsers': '同钱包用户',
  'member.detail.riskControl.ipAddress': 'ip地址',
  'member.detail.riskControl.ipRegion': 'IP所属区域',
  'member.detail.riskControl.deviceId': '设备ID',
  'member.detail.riskControl.deviceType': '设备类型',
  'member.detail.riskControl.bankAccountName': '银行户名',
  'member.detail.riskControl.bankCardNumber': '银行卡号',
  'member.detail.riskControl.walletAccount': '钱包账号',
  'member.detail.riskControl.walletType': '钱包类型',
  'member.detail.riskControl.associatedAccounts': '关联账号',
  'member.detail.riskControl.expand': '展开',
  'member.detail.riskControl.allAccounts': '所有关联账号',
  'member.detail.riskControl.totalAccounts': '账号总数',
  'member.detail.riskControl.searchAccount': '搜索账号',
  'member.detail.riskControl.noAccountsFound': '未找到匹配的账号',

  // 邀请好友列表
  'inviterList.title': '邀请好友列表',
  'inviterList.column.chainTime': '成链时间',
  'inviterList.column.lastInviteTime': '最近邀请时间',
  'inviterList.column.lineCount': '整线总人数',
  'inviterList.column.belongAgent': '归属代理',
  'inviterList.agentUnassigned': '未分配',
  'inviterList.editAgent': '编辑',
  'inviterList.agentFilterPlaceholder': '全部（可搜索）',
  'inviterList.topInviter': '顶级',
  'inviterList.depth.level': '{{level}} 级好友',
  'inviterList.status.valid': '有效',
  'inviterList.status.notQualified': '未达标',
  'inviterList.tag.inviteeBlocked': '被邀请人黑',
  'inviterList.tag.inviterBlocked': '邀请人黑',
  'inviterList.action.drill': '查看下级',
  'inviterList.action.report': '报表',
  'inviterList.filter.account': '用户账号',
  'inviterList.filter.accountPlaceholder': '请输入用户账号',
  'inviterList.filter.tag': '用户标签',
  'inviterList.filter.currency': '币种',
  'inviterList.filter.tagPlaceholder': '如「推广专员」',
  'inviterList.inviter': '邀请人',
  'inviterList.inviterPlaceholder': '请输入邀请人账号或 UID',
  'inviterList.inviteCode': '邀请码',
  'inviterList.inviteCodePlaceholder': '请输入邀请码',
  'inviterList.inviteStatus': '邀请状态',
  'inviterList.status.all': '全部',
  'inviterList.status.normal': '正常',
  'inviterList.status.blacklist': '黑名单',
  'inviterList.search': '搜索',
  'inviterList.reset': '重置',
  'inviterList.export': '导出',
  'inviterList.exporting': '正在导出，请稍候...',
  'inviterList.exportSuccess': '导出成功',
  'inviterList.exportFailed': '导出失败',
  'inviterList.inviteSettings': '邀请设置',
  'inviterList.searchHint': '邀请人或邀请码至少填写一项。',
  'inviterList.registerTime': '注册时间',
  'inviterList.inviteCount': '邀请人数',
  'inviterList.validCount': '有效人数',
  'inviterList.depositUsers': '充值人数',
  'inviterList.metric.inviteCount': '邀请人数',
  'inviterList.metric.validCount': '有效人数',
  'inviterList.metric.depositCount': '充值人数',
  'inviterList.metricValue': '数值',
  'inviterList.action': '操作',
  'inviterList.detail': '详情',
  'inviterList.addBlacklist': '列入黑名单',
  'inviterList.removeBlacklist': '解除黑名单',
  'inviterList.total': '共 {count} 位邀请人。',
  'inviterList.uid': 'UID',
  'inviterList.requestFailed': '请求失败',
  'inviterList.setting': '设置',
  'inviterList.delete': '删除',
  'inviterList.currentStatus': '当前状态',
  'inviterList.currencySwitchHint': '币种切换将影响统计区块与列表数据。',

  // 被邀请用户
  'inviterList.invitee.title': '被邀请用户',
  'inviterList.invitee.account': '会员账户',
  'inviterList.invitee.memberId': '会员账户',
  'inviterList.invitee.memberIdPlaceholder': '请输入会员账户（会员ID）',
  'inviterList.invitee.status': '被邀请人状态',
  'inviterList.invitee.level': '层级',
  'inviterList.invitee.level.1': '一级好友',
  'inviterList.invitee.level.2': '二级好友',
  'inviterList.invitee.level.3': '三级好友',
  'inviterList.invitee.level.n': '{{level}} 级好友',
  'inviterList.inviteeStatus.valid': '有效',
  'inviterList.inviteeStatus.invalid': '无效',
  'inviterList.inviteeStatus.blacklist': '拉黑',
  'inviterList.invitee.registerTime': '注册时间',
  'inviterList.invitee.effectiveTime': '有效时间',
  'inviterList.invitee.firstDepositAmount': '首次充值金额',
  'inviterList.invitee.firstDepositTime': '首次充值时间',
  'inviterList.invitee.totalDeposit': '有效金额',
  'inviterList.invitee.totalFlow': '有效流水',
  'inviterList.invitee.currentStatus': '当前状态',
  'inviterList.invitee.timeMode': '时间选择',
  'inviterList.invitee.timeMode.none': '无',
  'inviterList.invitee.timeMode.register': '注册时间',
  'inviterList.invitee.timeMode.effective': '有效时间',
  'inviterList.invitee.startDate': '开始日期',
  'inviterList.invitee.endDate': '结束日期',
  'inviterList.invitee.stats.depositUsers': '有效人数',
  'inviterList.invitee.stats.totalDeposit': '总充值',
  'inviterList.invitee.stats.totalFlow': '有效流水',
  'inviterList.invitee.total': '共 {count} 位被邀请用户（{currency}）。',
  'inviterList.invitee.loadMore': '展示更多（已展示 {{loaded}} / 共 {{total}}）',

  // 被邀请用户设置
  'inviterList.inviteeSetting.title': '被邀请用户设置',
  'inviterList.inviteeSetting.warning': '该操作会影响邀请关系与奖励发放，请确认后执行。',
  'inviterList.inviteeSetting.actionType': '可执行操作',
  'inviterList.inviteeSetting.setValid': '取消黑名单',
  'inviterList.inviteeSetting.setInvalid': '设置为黑名单',
  'inviterList.inviteeSetting.actionHint': '设置为有效：仅校验存款门槛与时效性；设置为无效：直接生效并清空有效时间。',
  'inviterList.inviteeSetting.reason': '操作原因',
  'inviterList.inviteeSetting.reasonPlaceholder': '请输入操作原因（必填）',
  'inviterList.inviteeSetting.reasonRequired': '操作原因必填',
  'inviterList.inviteeSetting.history.title': '历史记录',
  'inviterList.inviteeSetting.history.time': '时间',
  'inviterList.inviteeSetting.history.action': '操作',
  'inviterList.inviteeSetting.history.operator': '操作人',
  'inviterList.inviteeSetting.history.reason': '原因',
  'inviterList.inviteeSetting.history.add': '增加风控',
  'inviterList.inviteeSetting.history.remove': '解除风控',
  'inviterList.inviteeSetting.success': '操作成功',
  'inviterList.inviteeSetting.failed': '操作失败',

  // 黑名单
  'inviterList.blacklist.addTitle': '列入邀请黑名单',
  'inviterList.blacklist.removeTitle': '解除邀请黑名单',
  'inviterList.blacklist.warning': '该操作会影响邀请关系与奖励发放，请确认后执行。',
  'inviterList.blacklist.reason': '操作原因',
  'inviterList.blacklist.reasonPlaceholder': '请输入操作原因（必填）',
  'inviterList.blacklist.reasonRequired': '操作原因必填',
  'inviterList.blacklist.history.title': '历史记录',
  'inviterList.blacklist.history.time': '时间',
  'inviterList.blacklist.history.action': '操作',
  'inviterList.blacklist.history.operator': '操作人',
  'inviterList.blacklist.history.reason': '原因',
  'inviterList.blacklist.history.add': '增加风控',
  'inviterList.blacklist.history.remove': '解除风控',
  'inviterList.blacklist.addSuccess': '已列入黑名单',
  'inviterList.blacklist.removeSuccess': '已解除黑名单',
  'inviterList.blacklist.failed': '操作失败',

  // 邀请设置
  'inviterList.inviteSettings.title': '邀请设置',
  'inviterList.inviteSettings.systemStatus': '系统功能状态',
  'inviterList.inviteSettings.systemStatusHint': '仅后台控制，不对外展示。',
  'inviterList.inviteSettings.enabled': '开启',
  'inviterList.inviteSettings.disabled': '关闭',
  'inviterList.inviteSettings.effectiveTime': '生效时间',
  'inviterList.inviteSettings.longTerm': '长期',
  'inviterList.inviteSettings.timeRange': '指定时间段',
  'inviterList.inviteSettings.shareDomain': '前台分享链接主域名',
  'inviterList.inviteSettings.currencyConfigs': '币种配置（复数）',
  'inviterList.inviteSettings.currencyConfigsHint': '每个币种一套"有效用户定义"（金额不同不能共用）。',
  'inviterList.inviteSettings.addCurrencyConfig': '新增币种配置',
  'inviterList.inviteSettings.currency': '币种',
  'inviterList.inviteSettings.relatedPromo': '关联优惠',
  'inviterList.inviteSettings.selectPromo': '选择优惠名称',
  'inviterList.inviteSettings.defaultPromo': '邀请好友（默认）',
  'inviterList.inviteSettings.depositThreshold': '累计存款门槛',
  'inviterList.inviteSettings.depositFlowThreshold': '累计有效流水门槛',
  'inviterList.inviteSettings.amount': '金额',
  'inviterList.inviteSettings.timeLimit': '达标时间限制',
  'inviterList.inviteSettings.timeLimit.afterRegister': '注册后',
  'inviterList.inviteSettings.timeLimit.inActive': '在活动有效期内完成',
  'inviterList.inviteSettings.days': '天',
  'inviterList.inviteSettings.tip': '提示',
  'inviterList.inviteSettings.tipContent': '"设为有效"仅校验：存款门槛与时效性（注册后 N 天 / 活动有效期内完成）。',
  'inviterList.inviteSettings.saveSuccess': '保存成功',
  'inviterList.inviteSettings.saveFailed': '保存失败',
  'inviterList.inviteSettings.duplicateCurrency': '币种 {currencies} 存在重复配置，同币种只能新增一套配置',
  'inviterList.inviteSettings.currencyExists': '币种 {currency} 已存在配置，同币种只能新增一套配置',

  // 坏账记录
  'member.badDebt.columns.badDebtTime': '坏账时间',
  'member.badDebt.columns.betOrderNo': '注单号',
  'member.badDebt.columns.externalBetOrderNo': '订单号',
  'member.badDebt.columns.gamePlatform': '游戏平台',
  'member.badDebt.columns.gameType': '游戏类型',
  'member.badDebt.columns.betTime': '下注时间',
  'member.badDebt.columns.settleTime': '结算时间',
  'member.badDebt.columns.betAmount': '下注金额',
  'member.badDebt.columns.payoutAmount': '派彩金额',
  'member.badDebt.columns.badDebtAmount': '坏账金额（应收）',
  'member.badDebt.columns.deductedAmount': '已扣金额（已收）',
  'member.badDebt.columns.undeductedAmount': '未扣金额（未收）',
  'member.badDebt.columns.badDebtStatus': '坏账状态',
  'member.badDebt.columns.lastDeductionTime': '最后扣款时间',
  'member.badDebt.columns.operation': '操作',
  'member.badDebt.search.badDebtTime': '坏账时间',
  'member.badDebt.search.badDebtStatus': '坏账状态',
  'member.badDebt.search.gamePlatform': '游戏平台',
  'member.badDebt.search.gameType': '游戏类型',
  'member.badDebt.search.betOrderNo': '注单号',
  'member.badDebt.search.externalBetOrderNo': '订单号',
  'member.badDebt.search.externalBetOrderNoPlaceholder': '请输入订单号',
  'member.badDebt.search.selectBadDebtStatus': '请选择坏账状态',
  'member.badDebt.search.selectGamePlatform': '全部',
  'member.badDebt.search.selectGameType': '全部',
  'member.badDebt.search.betOrderNoPlaceholder': '请输入',
  'member.badDebt.search.query': '查询',
  'member.badDebt.search.refresh': '刷新',
  'member.badDebt.search.export': '导出',
  'member.badDebt.status.pending': '待扣款',
  'member.badDebt.status.partial': '部分扣款',
  'member.badDebt.status.settled': '已结清',
  'member.badDebt.status.writtenOff': '已清账',
  'member.badDebt.operation.viewDetail': '查看详情',
  'member.badDebt.detail.title': '坏账详情',
  'member.badDebt.detail.basicInfo': '基础信息',
  'member.badDebt.detail.memberAccount': '会员账户',
  'member.badDebt.detail.platformName': '平台名称',
  'member.badDebt.detail.currency': '币种',
  'member.badDebt.detail.gameName': '游戏名称',
  'member.badDebt.detail.deductionHistory': '扣款历史',
  'member.badDebt.detail.deductionTime': '扣款时间',
  'member.badDebt.detail.badDebtAmount': '坏账金额',
  'member.badDebt.detail.deductAmount': '扣款金额',
  'member.badDebt.detail.badDebtStatus': '坏账状态',
  'member.badDebt.detail.remark': '备注',
  'member.badDebt.writeOff.button': '清账',
  'member.badDebt.writeOff.confirmTitle': '确认清账',
  'member.badDebt.writeOff.confirmContent': '确定要清账吗？此操作不可撤销。',
  'member.badDebt.writeOff.defaultRemark': '人工清账',
  'member.badDebt.message.viewDetailComingSoon': '查看详情功能开发中',
  'member.badDebt.message.dataPkCodeRequired': '数据标识码不存在',
  'member.badDebt.message.fetchDetailFailed': '获取详情失败',
  'member.badDebt.message.writeOffSuccess': '清账成功',
  'member.badDebt.message.writeOffFailed': '清账失败',
  'member.badDebt.error.fetchFailed': '获取坏账数据失败',
  'member.badDebt.message.selectMember': '请先选择会员',
  'member.badDebt.message.exporting': '正在导出...',
  'member.badDebt.message.exportSuccess': '导出成功',
  'member.badDebt.message.exportFailed': '导出失败',
  // Common translations for bad debt detail modal
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.close': '关闭',
  'common.loading': '加载中...',
  'common.noData': '暂无数据',

  // 存款用户列表页面
  'depositMemberList.title': '存款用户列表',
  'depositMemberList.subtitle': '(除了时间筛选外,至少填写一项查询条件)',
  'depositMemberList.searchWarning': '请至少填写一项查询条件',
  'depositMemberList.timeRequired': '请选择时间范围',
  'depositMemberList.currencyRequiredForRecharge': '使用充值次数或充值金额筛选时，请先选择币种',
  'depositMemberList.currencyRequiredForTimeType': '选择首充时间或最近充值时间时，请同时选择币种',
  'depositMemberList.timeType': '时间类型',
  'depositMemberList.lastRechargeTime': '最近充值时间',
  'depositMemberList.firstRechargeTime': '首充时间',
  'depositMemberList.registerTime': '注册时间',
  'depositMemberList.memberAccount': '会员账户',
  'depositMemberList.memberAccountLabel': '会员账号',
  'depositMemberList.memberAccountPlaceholder': '请输入会员账号',
  'depositMemberList.realName': '会员真实姓名',
  'depositMemberList.realNameLabel': '会员真实姓名',
  'depositMemberList.realNamePlaceholder': '请输入会员真实姓名',
  'depositMemberList.memberNameLabel': '会员昵称',
  'depositMemberList.agentAccount': '上级代理账号',
  'depositMemberList.agentAccountPlaceholder': '请输入上级代理账号',
  'depositMemberList.rechargeCount': '充值次数',
  'depositMemberList.rechargeCountPlaceholder': '请输入最小充值次数',
  'depositMemberList.rechargeAmount': '充值金额',
  'depositMemberList.rechargeAmountPlaceholder': '请输入最小充值金额',
  'depositMemberList.excludeAgent': '排除指定代理',
  'depositMemberList.excludeAgentPlaceholder': '选择要排除的代理（可搜索，可多选）',
  'depositMemberList.excludeAllAgent': '排除全部代理',
  'depositMemberList.excludeOfficialUser': '排除官网用户',
  'depositMemberList.mobileValid': '手机号已认证用户',
  'depositMemberList.smsTask': '关联短信任务',
  'depositMemberList.smsTaskPlaceholder': '选择要筛选的短信任务',
  'depositMemberList.matchedUsers': '个匹配用户',
  'depositMemberList.search': '查询',
  'depositMemberList.reset': '重置',
  'depositMemberList.export': '导出',
  'depositMemberList.vipLevel': '会员等级',
  'depositMemberList.registerInfo': '注册信息',
  'depositMemberList.registerIp': '注册IP',
  'depositMemberList.depositCount': '充值次数',
  'depositMemberList.firstDepositAmount': '首次充值金额',
  'depositMemberList.firstDepositTime': '首次充值时间',
  'depositMemberList.lastDepositAmount': '最后充值金额',
  'depositMemberList.lastDepositTime': '最后充值时间',
  'depositMemberList.totalDeposit': '总充值',
  'depositMemberList.totalWithdraw': '总提现',
  'depositMemberList.depositWithdrawDiff': '充提差',
  'depositMemberList.action': '操作',
  'depositMemberList.view': '详情',
  // 充值歷史彈窗
  'depositMemberList.payOrderHistory.title': '充值历史',
  'depositMemberList.payOrderHistory.fetchError': '获取充值记录失败',
  'depositMemberList.payOrderHistory.orderNumber': '订单号',
  'depositMemberList.payOrderHistory.amount': '充值金额',
  'depositMemberList.payOrderHistory.paymentMethod': '支付方式',
  'depositMemberList.payOrderHistory.paymentChannel': '支付渠道',
  'depositMemberList.payOrderHistory.createTime': '创建时间',
  'depositMemberList.payOrderHistory.successTime': '支付成功时间',
  'depositMemberList.payOrderHistory.status': '状态',
  'depositMemberList.payOrderHistory.status.pending': '待支付',
  'depositMemberList.payOrderHistory.status.paid': '已支付',
  'depositMemberList.payOrderHistory.status.expired': '已过期',
  'depositMemberList.payOrderHistory.status.invalid': '无效订单',

  // VIP用户列表页面
  'vipMemberList.title': 'VIP用户列表',
  'vipMemberList.timeRequired': '请选择时间范围',
  'vipMemberList.currencyRequiredForRecharge': '使用充值次数或充值金额或提现次数筛选时，请先选择币种',
  'vipMemberList.currencyRequiredForTimeType': '选择最后充值时间时，请同时选择币种',
  'vipMemberList.timeType': '时间类型',
  'vipMemberList.lastRechargeTime': '最后充值时间',
  'vipMemberList.firstRechargeTime': '首充时间',
  'vipMemberList.registerTime': '注册时间',
  'vipMemberList.memberAccount': '会员账户',
  'vipMemberList.memberAccountLabel': '会员账号',
  'vipMemberList.memberAccountPlaceholder': '请输入会员账号',
  'vipMemberList.realName': '会员真实姓名',
  'vipMemberList.realNameLabel': '会员真实姓名',
  'vipMemberList.realNamePlaceholder': '请输入会员真实姓名',
  'vipMemberList.memberNameLabel': '会员昵称',
  'vipMemberList.agentAccount': '上级代理账号',
  'vipMemberList.agentAccountPlaceholder': '请输入上级代理账号',
  'vipMemberList.rechargeCount': '充值次数',
  'vipMemberList.rechargeCountPlaceholder': '请输入最小充值次数',
  'vipMemberList.rechargeAmount': '充值金额',
  'vipMemberList.rechargeAmountPlaceholder': '请输入最小充值金额',
  'vipMemberList.withdrawCountPlaceholder': '请输入最小提款次数',
  'vipMemberList.excludeAgent': '排除指定代理',
  'vipMemberList.excludeAgentPlaceholder': '选择要排除的代理（可搜索，可多选）',
  'vipMemberList.excludeAllAgent': '排除全部代理',
  'vipMemberList.excludeOfficialUser': '排除官网用户',
  'vipMemberList.smsTask': '关联短信任务',
  'vipMemberList.smsTaskPlaceholder': '选择要筛选的短信任务',
  'vipMemberList.search': '查询',
  'vipMemberList.reset': '重置',
  'vipMemberList.export': '导出',
  'vipMemberList.vipLevel': '会员等级',
  'vipMemberList.registerInfo': '注册信息',
  'vipMemberList.registerIp': '注册IP',
  'vipMemberList.lastDepositTime': '最后充值时间',
  'vipMemberList.totalDeposit': '总充值',
  'vipMemberList.totalWithdraw': '总提现',
  'vipMemberList.depositWithdrawDiff': '充提差',
  'vipMemberList.totalBetAmount': '总投注',
  'vipMemberList.totalWinLoss': '总输赢',
  'vipMemberList.lastBetTime': '最后投注时间',
  'vipMemberList.lastLoginTime': '最后登录时间',
  'vipMemberList.vipLevelTime': 'VIP等级变更时间',
  'vipMemberList.action': '操作',
  'vipMemberList.view': '详情',

  // 裂变用户查询页面
  'jeepneyUserList.title': '裂变用户查询',
  'jeepneyUserList.timeType': '时间类型',
  'jeepneyUserList.lastLoginTime': '最后登录时间',
  'jeepneyUserList.lastAdvanceTime': '最后推进时间',
  'jeepneyUserList.memberAccount': '会员账号',
  'jeepneyUserList.memberAccountPlaceholder': '请输入会员账号',
  'jeepneyUserList.accountLabel': '账号',
  'jeepneyUserList.memberAccountLabel': '会员账号',
  'jeepneyUserList.memberRealNameLabel': '会员真实姓名',
  'jeepneyUserList.memberNicknameLabel': '会员昵称',
  'jeepneyUserList.realName': '会员真实姓名',
  'jeepneyUserList.realNamePlaceholder': '',
  'jeepneyUserList.realNameLabel': '姓名',
  'jeepneyUserList.nicknameLabel': '昵称',
  'jeepneyUserList.vipLevel': 'VIP等级',
  'jeepneyUserList.memberLevel': '会员等级',
  'jeepneyUserList.currentRound': '当前轮次',
  'jeepneyUserList.currentStage': '当前关卡',
  'jeepneyUserList.rechargeCount': '充值次数',
  'jeepneyUserList.rechargeAmount': '充值金额',
  'jeepneyUserList.settlementSuccessCount': '结算成功次数',
  'jeepneyUserList.settlementFailureCount': '结算失败次数',
  'jeepneyUserList.inviteCount': '邀请人数',
  'jeepneyUserList.validInviteCount': '有效邀请人数',
  'jeepneyUserList.pointsExchangeCount': '积分兑换次数',
  'jeepneyUserList.currency': '币种',
  'jeepneyUserList.currencyAll': '全部',
  'jeepneyUserList.distributedAmount': '已派发金额',
  'jeepneyUserList.fuelCurrency': '推进货币',
  'jeepneyUserList.fuelCurrencyTitle': '推进货币明细',
  'jeepneyUserList.viewDetail': '查看明细',
  'jeepneyUserList.fuelBalance': '燃料余额',
  'jeepneyUserList.fuelEarned': '获得燃料',
  'jeepneyUserList.fuelConsumed': '消耗燃料',
  'jeepneyUserList.fuelConsumedShort': '消耗',
  'jeepneyUserList.fuelEarnedShort': '获取',
  'jeepneyUserList.fuelBalanceShort': '余额',
  'jeepneyUserList.fuelItem': '项目',
  'jeepneyUserList.fuelValue': '数值',
  'jeepneyUserList.fuelDate': '日期',
  'jeepneyUserList.fuelMemberAccount': '会员账户',
  'jeepneyUserList.fuelTransactionType': '类型',
  'jeepneyUserList.fuelSourceType': '来源',
  'jeepneyUserList.fuelSourceTypeLabel': '奖励来源',
  'jeepneyUserList.fuelTransactionTypeLabel': '货币类型',
  'jeepneyUserList.fuelAmount': '变动货币',
  'jeepneyUserList.fuelBalanceBefore': '变动前',
  'jeepneyUserList.fuelBalanceAfter': '变动后',
  'jeepneyUserList.sourceTypeAll': '全部',
  'jeepneyUserList.sourceTypeStageConsume': '闯关消耗',
  'jeepneyUserList.sourceTypeRoundClear': '回合结束清空',
  'jeepneyUserList.sourceTypeRecharge': '充值加油',
  'jeepneyUserList.sourceTypeInvite': '邀请加油',
  'jeepneyUserList.sourceTypeEntry': '入场奖励',
  'jeepneyUserList.sourceTypeStage': '闯关奖励',
  'jeepneyUserList.sourceTypePointsExchange': '积分兑换推进货币',
  'jeepneyUserList.transactionTypeAll': '全部',
  'jeepneyUserList.transactionTypeIncome': '获取',
  'jeepneyUserList.transactionTypeExpense': '消耗',
  'jeepneyUserList.cashRewardTotal': '现金奖励-累计获得',
  'jeepneyUserList.cashRewardDistributed': '现金奖励-已派发',
  'jeepneyUserList.cashRewardDistributedTooltip': '实际活动成本',
  'jeepneyUserList.cashRewardTotalTooltip': '历史累计中奖总额，含放弃或结算失败被清空的部分，不代表应付金额',
  'jeepneyUserList.currentRoundPendingCash': '本轮待结算',
  'jeepneyUserList.currentRoundPendingCashTooltip': '当前轮次已中奖但尚未派发的金额，结算成功才会发放，放弃或结算失败则清空',
  'jeepneyUserList.totalPointsEarned': '累计获得积分',
  'jeepneyUserList.totalSpinTicketsEarned': '累计获得转盘券',
  'jeepneyUserList.returnRate': '回报率',
  'jeepneyUserList.operation': '操作',
  'jeepneyUserList.rewardDetail': '奖励明细',
  'jeepneyUserList.search': '查询',
  'jeepneyUserList.reset': '重置',
  'jeepneyUserList.export': '导出',
  'jeepneyUserList.exportLoading': '正在导出数据...',
  'jeepneyUserList.exportSuccess': '导出成功',
  'jeepneyUserList.exportFail': '导出失败',
  'jeepneyUserList.hourlyUpdate': '每小时更新',
  'jeepneyUserList.totalActivityCost': '总活动成本',
  'jeepneyUserList.totalReturnRate': '总回报率',
  // 导入操作管理
  'importLog.title': '导入操作管理',
  'importLog.fileName': '文件名',
  'importLog.fileNamePlaceholder': '请输入文件名',
  'importLog.createTime': '提交时间',
  'importLog.completeTime': '完成时间',
  'importLog.totalCount': '总条数',
  'importLog.successCount': '成功条数',
  'importLog.failCount': '失败条数',
  'importLog.status': '状态',
  'importLog.statusPending': '处理中',
  'importLog.statusComplete': '已完成',
  'importLog.action': '操作',
  'importLog.viewDetail': '查看明细',
  'importLog.search': '查询',
  'importLog.reset': '重置',
  'importLog.requestFailed': '查询失败',
  'importLog.detail.title': '导入明细',
  'importLog.detail.close': '关闭',
  'importLog.detail.loading': '载入中...',
  'importLog.detail.headerFileName': '导入文件名',
  'importLog.detail.headerOperator': '操作人',
  'importLog.detail.headerCreateTime': '提交时间',
  'importLog.detail.headerCompleteTime': '完成时间',
  'importLog.detail.headerStatus': '导入状态',
  'importLog.detail.memberAccount': '会员账号',
  'importLog.detail.memberAccountPlaceholder': '搜索失败用户名',
  'importLog.detail.failureReason': '失败原因',
  'importLog.detail.failureTitle': '失败明细',
  'importLog.detail.hint': '提示：仅保留一个月内失败用户账号',
  'importLog.detail.noFailedRecords': '没有失败记录',
  'importLog.detail.noRecords': '暂无导入记录',

  // 負盈利用戶列表頁面
  'negativeProfitMember.title': '负盈利用户列表',
  'negativeProfitMember.dateRangeHint': '默认昨日，查询结果为选择的日期区间数据汇总 （历史 = 不含今日）',
  'negativeProfitMember.hint': '(除了时间筛选外,至少填写一项查询条件)',
  'negativeProfitMember.dateRange': '统计日期',
  'negativeProfitMember.selectVipLevel': '请选择VIP等级',
  'negativeProfitMember.selectAll': '全选',
  'negativeProfitMember.curDataPkCode': '判定币种',
  'negativeProfitMember.curDataPkCodeRequired': '请选择判定币种',
  'negativeProfitMember.selectCurDataPkCode': '请选择判定币种',
  'negativeProfitMember.lossThreshold': '输钱阈值 ≥',
  'negativeProfitMember.lossThresholdPlaceholder': '最低净输100',
  'negativeProfitMember.memberAccount': '会员账户',
  'negativeProfitMember.memberAccountPlaceholder': '请输入会员账户',
  'negativeProfitMember.vipLevel': 'VIP等级',
  'negativeProfitMember.agentAccount': '上级代理账号',
  'negativeProfitMember.agentAccountPlaceholder': '请输入上级代理账号',
  'negativeProfitMember.minDepositCount': '历史充值次数',
  'negativeProfitMember.minDepositCountPlaceholder': '请输入充值次数',
  'negativeProfitMember.minDepositAmount': '历史充值金额',
  'negativeProfitMember.minDepositAmountPlaceholder': '请输入充值金额',
  'negativeProfitMember.minWithdrawCount': '历史提现次数',
  'negativeProfitMember.minWithdrawCountPlaceholder': '请输入提现次数',
  'negativeProfitMember.minWithdrawAmount': '历史提现金额',
  'negativeProfitMember.minWithdrawAmountPlaceholder': '请输入提现金额',
  'negativeProfitMember.loginChannel': '登录终端',
  'negativeProfitMember.selectLoginChannel': '请选择登录终端',
  'negativeProfitMember.registerInfo': '注册信息',
  'negativeProfitMember.registerTime': '注册时间',
  'negativeProfitMember.registerIp': '注册IP',
  'negativeProfitMember.realName': '真实姓名',
  'negativeProfitMember.nickname': '昵称',
  'negativeProfitMember.depositCount': '历史充值次数',
  'negativeProfitMember.withdrawCount': '历史提现次数',
  'negativeProfitMember.depositAmount': '历史总充值 (多币种)',
  'negativeProfitMember.withdrawAmount': '历史总提现 (多币种)',
  'negativeProfitMember.depositWithdrawDiff': '历史充提差 (多币种)',
  'negativeProfitMember.bettingAmount': '历史总投注 (多币种)',
  'negativeProfitMember.profitLoss': '历史总输赢 (多币种)',
  'negativeProfitMember.totalProfitLoss': '累计总输赢 (多币种)',
  'negativeProfitMember.lastLoginTime': '最近登录时间',
  'negativeProfitMember.requestFailed': '查询失败',
  'negativeProfitMember.exportSuccess': '导出成功',
  'negativeProfitMember.exportFailed': '导出失败',
  'negativeProfitMember.exportLoading': '导出中...',
  'negativeProfitMember.exportWarning': '请先填写查询条件再导出'
};
